package repdb

import com.ustadmobile.door.DoorDatabaseWrapper
import com.ustadmobile.door.log.DoorLogger
import com.ustadmobile.door.message.DoorMessageCallback
import com.ustadmobile.door.nodeevent.NodeEventManagerCommon
import com.ustadmobile.door.nodeevent.NodeEventManagerJs
import com.ustadmobile.door.room.InvalidationTracker
import com.ustadmobile.door.room.RoomDatabase
import kotlin.Any
import kotlin.IllegalArgumentException
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import kotlin.reflect.KClass
import kotlinx.coroutines.Runnable

@Suppress("REDUNDANT_PROJECTION", "ClassName")
public class RepDb_DoorWrapper(
  private val _db: RepDb,
  override val nodeId: Long,
  private val messageCallback: DoorMessageCallback<RepDb>,
  logger: DoorLogger,
  dbName: String,
) : RepDb(), DoorDatabaseWrapper<RepDb> {
  override val dbVersion: Int
    get() = 1

  override val dbName: String
    get() = "DoorWrapper for [${_db.toString()}]"

  public val _RepDao: RepDao by lazy  {
        RepDao_DoorWrapper(_db, _db.repDao)
      }


  override val repDao: RepDao
    get() = _RepDao

  override val compositePkDao: CompositePkDao
    get() = _db.compositePkDao

  public val _RepWithAttachmentDao: RepWithAttachmentDao by lazy  {
        RepWithAttachmentDao_DoorWrapper(_db, _db.repWithAttachmentDao)
      }


  override val repWithAttachmentDao: RepWithAttachmentDao
    get() = _RepWithAttachmentDao

  override val realDatabase: RoomDatabase
    get() = _db

  override val nodeEventManager: NodeEventManagerCommon<RepDb> = NodeEventManagerJs(_db,
      messageCallback, logger, dbName)


  override val invalidationTracker: InvalidationTracker
    get() = _db.invalidationTracker

  override fun createAllTables(): List<String> = _db.createAllTables()

  override suspend fun clearAllTablesAsync() {
    _db.clearAllTablesAsync()
  }

  override fun clearAllTables() {
    _db.clearAllTables()
  }

  override fun runInTransaction(runnable: Runnable) {
    _db.runInTransaction(runnable)
  }

  @Suppress("UNCHECKED_CAST")
  override fun <T : Any> getDaoByClass(daoClass: KClass<T>): T = when(daoClass) {
    RepDao::class -> repDao as T
    CompositePkDao::class -> compositePkDao as T
    RepWithAttachmentDao::class -> repWithAttachmentDao as T
    else -> throw IllegalArgumentException("No such DAO on this DB")
  }

  override fun close() {
    _db.close()
  }
}
